// accept only whole integers strictly greater than zero, rejecting any
// trailing/non-numeric characters so "18x" is not accepted as 18
export const isPositiveInteger = (value) => {
    const trimmed = String(value).trim();
    if (!/^\d+$/.test(trimmed)) {
        return false;
    }
    return parseInt(trimmed, 10) > 0;
}

export const isValidSyncSettings = (settings) => {
    return settings &&
        isPositiveInteger(settings.initial_incident_download_months) &&
        isPositiveInteger(settings.offline_incident_retention_months);
}
